import { Badge } from "@/design-system/components/ui";
import type { CounterpartyStatus } from "@/types/counterparties";

interface StatusBadgeProps {
  status: CounterpartyStatus;
}

export function CounterpartyStatusBadge({ status }: StatusBadgeProps) {
  if (status === "Archived") {
    return <Badge status="archived">Archived</Badge>;
  }
  return <Badge status="finalized">Active</Badge>;
}
